import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { useOktaAuth } from '@okta/okta-react'
import { ROUTES } from '@/constants/routes'

/**
 * Protects routes when using Okta. If not authenticated, redirects to the
 * login page (not directly to Okta) so the user sees the "Sign in with Okta"
 * button and can choose to sign in.
 */
export default function RequireAuth() {
  const { authState } = useOktaAuth()
  const location = useLocation()

  if (!authState) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-primary-50">
        <p className="text-black-sub font-sans">Loading...</p>
      </div>
    )
  }

  if (!authState.isAuthenticated) {
    // Redirect to our login page, preserving the original URL so we can
    // return to it after successful authentication.
    return <Navigate to={ROUTES.LOGIN} state={{ from: location.pathname }} replace />
  }

  return <Outlet />
}
